module.exports = __webpack_public_path__ + "static/media/choithramsSliderTwo.19020757.jpg";